import is from 'is_js';
import filter from 'lodash/filter';

const searchFilterApiAdapter = (searchFilterValues) => {
  const Keyword = searchFilterValues.keyword
    ?
    {
      Name: 'Keyword',
      Value: searchFilterValues.keyword,
    }
    :
    null;

  const Section = searchFilterValues.sections
    ?
    {
      Name: 'Section',
      Values: [searchFilterValues.section],
    }
    :
    null;

  const possibleFilters = [
    Keyword,
    Section,
  ];

  return filter(possibleFilters, item => is.not.null(item));
};

export default searchFilterApiAdapter;
